// extracted by mini-css-extract-plugin
module.exports = {"replyButton":"KkXMX","replyIcon":"_3Cu5l"};